import React, { useEffect, useState } from "react";
import useWebSocket from 'react-use-websocket';
import logger from '../../utils/logger';

/**
 * props:
 * - text
 * - type
 */
function Toast(props) {

    const DEFAULT_NOTIFICATION = { type: '', text: '' };

    const [notification, setNotification] = useState(DEFAULT_NOTIFICATION);

    useEffect(() => {
        if (!notification.text) return;

        const notyf = new window.Notyf({
            position: {
                x: 'right',
                y: 'top',
            },
            // Auto-dismiss after 6s (was 0 = never, so toasts piled up and never left).
            // `dismissible` keeps the × for closing earlier.
            duration: 6000,
            types: [
                {
                    type: 'info',
                    background: 'blue',
                    dismissible: true
                },
                {
                    type: 'error',
                    background: 'red',
                    dismissible: true
                },
                {
                    type: 'success',
                    background: 'green',
                    dismissible: true
                }
            ]
        });

        notyf.open({
            type: notification.type,
            message: notification.text
        })
            .on('dismiss', ({ target, event }) => {
                setNotification(DEFAULT_NOTIFICATION);
            });
        //setNotification(DEFAULT_NOTIFICATION);
    }, [notification])

    useEffect(() => {
        setNotification({ type: props.type, text: props.text });
    }, [props.type, props.text])

    const { lastJsonMessage } = useWebSocket(process.env.REACT_APP_WS_URL, {
        onOpen: () => {
            logger.log(`Connected to App WS`);
        },
        onMessage: () => {
            if (lastJsonMessage && lastJsonMessage.notification) {
                setNotification(lastJsonMessage.notification);
            }
        },
        queryParams: { 'token': localStorage.getItem("token") },
        onError: (event) => {
            // WebSocket errors are transient (reconnect, token expiry, network).
            // Log them — never surface the raw event to the user as a toast
            // (that produced the "{"isTrusted":true}" error popup). Auto-reconnect handles recovery.
            logger.error(event);
        },
        shouldReconnect: (closeEvent) => true,
        reconnectInterval: 3000
    });

    return (
        <React.Fragment></React.Fragment>
    )
}

export default Toast;